module.exports = __webpack_public_path__ + "static/media/new-close-icon-mobile.518c38a1.svg";